import { takeLatest, put, call } from 'redux-saga/effects';

import { listRomaneioColheitaTable } from '../service';
import {
  TABLE_ROMANEIO_COLHEITA,
  TABLE_ROMANEIO_COLHEITA_PENDING,
  TABLE_ROMANEIO_COLHEITA_SUCCESS,
  TABLE_ROMANEIO_COLHEITA_FAILURE
} from '../actionTypes';

function* sagaListRomaneioColheita(action) {
  yield put({ type: TABLE_ROMANEIO_COLHEITA_PENDING })

  try {
    const table = yield call(listRomaneioColheitaTable, action.args)
    yield put({ type: TABLE_ROMANEIO_COLHEITA_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_ROMANEIO_COLHEITA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListRomaneioColheita() {
  yield takeLatest(TABLE_ROMANEIO_COLHEITA, sagaListRomaneioColheita)
}